export default "__VITE_ASSET__85FRNuId__"